type Environment = {
  networkName: 'localhost' | 'goerli' | 'Ethereum Mainnet';
  contractAddress: string;
  chainId: number;
  etherscanDomain: string;
  readOnlyProviderUrl: string;
};

const localhost: Environment = {
  networkName: 'localhost',
  contractAddress: '0x5fbdb2315678afecb367f032d93f642f64180aa3',
  etherscanDomain: 'local.etherscan.io',
  chainId: 1337,
  readOnlyProviderUrl: 'http://localhost:8545',
};

const goerli: Environment = {
  networkName: 'goerli',
  contractAddress: '0x45a71c5B66DaAE4175a05271BF59728f55A3a271',
  etherscanDomain: 'goerli.etherscan.io',
  chainId: 5,
  readOnlyProviderUrl:
    'https://goerli.infura.io/v3/d5ddd85e59974cd3bb803a4c835ecf87',
};

// TODO: Update to production values
const mainnet: Environment = {
  networkName: 'Ethereum Mainnet',
  contractAddress: '0x0DbB564beDC0255935DbD49812f30dc743ad10f1',
  etherscanDomain: 'etherscan.io',
  chainId: 3,
  readOnlyProviderUrl:
    'https://goerli.infura.io/v3/d5ddd85e59974cd3bb803a4c835ecf87',
};

const envLookup: { [key: string]: Environment | undefined } = {
  localhost: localhost,
  'goerli.piggybankbomb.com': goerli,
  'goerli.piggybankbomb.eth': goerli,
  'goerli.piggybankbomb.eth.link': goerli,
  'piggybankbomb.com': mainnet,
  'piggybankbomb.eth': mainnet,
  'piggybankbomb.eth.link': mainnet,
};

export const getEnvironmentForDomain = (domain: string): Environment => {
  const environment = envLookup[domain];

  if (!environment) {
    throw new Error(`No environment for domain: ${domain}`);
  }

  return environment;
};

export const getEnvironment = (): Environment =>
  getEnvironmentForDomain(window.location.hostname);
